import React from 'react';
import { colors } from 'app/shared/theme/colors';
import { useTranslation } from 'app/shared/i18n';

const PAGE_SIZES = [10, 20, 50, 100, 200, 1000];

interface Props {
  currentSize: number;
  onSizeChange: (size: number) => void;
}

export const PageSizeSelector = ({ currentSize, onSizeChange }: Props) => {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{ fontSize: 12, color: colors.dim }}>{t('common.show')}</span>
      <select
        value={currentSize}
        onChange={e => onSizeChange(Number(e.target.value))}
        style={{
          padding: '4px 8px',
          borderRadius: 6,
          border: `1px solid ${colors.border}`,
          background: colors.surface,
          color: colors.text,
          fontSize: 12,
          fontFamily: "'JetBrains Mono', monospace",
          cursor: 'pointer',
          outline: 'none',
        }}
      >
        {PAGE_SIZES.map(size => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
      <span style={{ fontSize: 12, color: colors.dim }}>{t('common.perPage')}</span>
    </div>
  );
};
